import { axios } from '@/api/request'

/**
 * api接口列表
 */
const api = {
  login:'/qywxLogin/',
  getsendorders:'/teams/sendorder/'

}

export function login (data) {
  return axios({
    url: api.login,
    method: 'post',
    data
  })
}

export function getsendorders (params) {
  return axios({
    url: api.getsendorders,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/views/cangkuviews/sendorder/api.js